import React from 'react';

import DanielleImg from '../images/Testimonials/danielle.png';
import ShaunakImg from '../images/Testimonials/shaunak.jpeg';
import IsaacImg from '../images/Testimonials/isaac.jpeg';
import AmuraLogo from '../images/Testimonials/amura.jpeg';
import SupaLogo from '../images/Testimonials/supa.jpeg';
import { ReactComponent as XbertLogo } from '../images/Testimonials/xbert.svg';

const TESTIMONIALS = [
  {
    id: 1,
    name: 'Danielle Kavanaugh',
    company: 'Nextiva',
    personImage: DanielleImg,
    companyLogoSvg: XbertLogo,
    testimonial: "I can confidently say Chinmay is one of the most well-rounded collaborators I've worked with. He leads by example. When something needs to get done, he steps up without hesitation and helps create a clear path forward. Additionally, no matter how busy things get, he always make time to help unblock others. Chinmay is also a fantastic thought partner. He actively listens and takes your input seriously, and you can see it reflected in the work. Lastly he's able to break complex problems into well thought and visually strong designs. Any team would be lucky to have him.",
  },
  {
    id: 2,
    name: 'Isaac Tan',
    company: 'Supahands',
    personImage: IsaacImg,
    companyLogo: SupaLogo,
    testimonial: "Chinmay has been a real pleasure to work with. He did an exceptional job on projects that we worked together on. Chinmay never hold back on suggestions for improvements and have constantly hold himself and others to a high standard. He has remarkably exceeded my expectations in his product innovations and technical knowledge that helped the company take a leap forward. I can recommend him as a person with great passion and deep experience in building amazing products.",
  },
  {
    id: 3,
    name: 'Shaunak Pagnis',
    company: 'AmuraTech',
    personImage: ShaunakImg,
    companyLogo: AmuraLogo,
    testimonial: "Chinmay worked with me at Amura as a UIUX developer for about two years. He has a knack for being intuitive and creative when it comes to developing UI. I mentored him when he was an intern and quickly understood that his inclination was towards being a UIUX developer and he turned out be a good one! I'd specifically like to mention the design system he built for an internal process management product we had developed for the company and the positive impact it did on the users.",
  },
];

function Testimonials() {
  return (
    <section className="testimonials-section">
      <p className="testimonials-section-label">Testimonials</p>
      <div className="testimonials-list">
        {TESTIMONIALS.map((t) => (
          <div key={t.id} className="testimonial-item">
            <p className="testimonial-text">{t.testimonial}</p>
            <div className="testimonial-footer">
              <div className="testimonial-avatar-wrapper">
                <div className="testimonial-avatar">
                  <img src={t.personImage} alt={t.name} loading="lazy" />
                </div>
                <div className="testimonial-company-badge">
                  {t.companyLogoSvg ? (
                    <t.companyLogoSvg aria-label={t.company} />
                  ) : (
                    <img src={t.companyLogo} alt={t.company} loading="lazy" />
                  )}
                </div>
              </div>
              <div className="testimonial-person-info">
                <p className="testimonial-name">{t.name}</p>
                <p className="testimonial-company">{t.company}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Testimonials;
